import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginFirstModalComponent } from '@curbnturf/auth-modal/src/lib/login-first-modal/login-first-modal.component';
import { Listing, User } from '@curbnturf/entities';
import { UserFacade } from '@curbnturf/user/src/lib/+state/user.facade';
import { IonicModule, ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { AskHostModalComponent } from '../ask-host-modal/ask-host-modal.component';

@Component({
  selector: 'curbnturf-contact-host',
  templateUrl: './contact-host.component.html',
  styleUrls: ['./contact-host.component.scss'],
  standalone: true,
  imports: [FormsModule, IonicModule, ReactiveFormsModule],
})
export class ContactHostComponent implements OnDestroy, OnInit {
  @Input() listing: Listing;

  user: User;

  private subscriptions: Subscription[] = [];

  constructor(
    private modalController: ModalController,
    private userFacade: UserFacade,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(this.userFacade.currentUserOnce$.subscribe((user) => (this.user = user)));
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  async openModal() {
    if (this.user?.id) {
      const modal = await this.modalController.create({
        component: AskHostModalComponent,
        componentProps: {
          listing: this.listing,
          user: this.user,
        },
        cssClass: 'confirm-modal center',
      });
      await modal.present();
    } else {
      const modal = await this.modalController.create({
        component: LoginFirstModalComponent,
        componentProps: {
          text: 'To message the host you must be logged in.',
          redirect: `/listing/${this.listing?.id}`,
        },
        cssClass: 'confirm-modal',
      });
      await modal.present();
    }
  }
}
